export default "/images/traveler.svg?00576a8b2f7071b0255ec7e9765f8f64";